<template>
  <div>
    <app-header></app-header>
      <v-container fluid grid-list-xl>
        <v-layout row warp justify-center align-center>
          <v-flex xs12 md12 lg10 sm12>
            <v-card class="mt-5 pa-5" flat>
              <v-form ref="formValidate">
                <v-text-field v-model="formValidate.postingTitle" :label="$t('postingcreate.Title')" :rules="titleRules" single-line outline></v-text-field>
                <!-- :class="[darkMode ? 'ql-toolbar-dark' : 'ql-toolbar-light',darkMode ? 'ql-container-dark' : 'ql-container-light']" -->
                <!-- 图片上传 -->
                <Upload
                    ref="upload" name="upfile"
                    :format="['jpg','jpeg','png','gif']"
                    :max-size="4096"
                    :headers="headers"
                    :action="uploadImageApi"
                    :with-credentials=true
                    :show-upload-list=false
                    :before-upload="uploadImageBefore"
                    class="d-none upload-image">
                  <Button icon="ios-cloud-upload-outline" ></Button>
                </Upload>
                <!-- 文件上传 -->
                <Upload
                    ref="upload" name="upfile"
                    :max-size="10240"
                    :headers="headers"
                    :action="uploadFileApi"
                    :with-credentials=true
                    :show-upload-list=false
                    :on-success="uploadFileSuccess"
                    :before-upload="uploadFileBefore"
                    class="d-none upload-file">
                  <Button icon="ios-cloud-upload-outline" ></Button>
                </Upload>
                <quill-editor id="quillEditor"
                  v-model="formValidate.postingContent"
                  ref="myQuillEditor"
                  class="mt-3"
                  :options="editorOption"
                  @blur="onEditorBlur($event)"
                  @focus="onEditorFocus($event)"
                  @ready="onEditorReady($event)"
                  @change="onEditorChange($event)"
                ></quill-editor>
                <div>
                  <v-btn
                    v-show="selectedMarket.marketId == null"
                    class="mt-5 ml-0"
                    small
                    flat
                    outline
                    color="primary"
                    @click="isShowMarketListDialog = !isShowMarketListDialog"
                  >{{$t("postingcreate.chooseTopic")}}</v-btn>
                  <v-btn
                    v-show="selectedMarket.marketId != null"
                    small
                    color="primary"
                    class="white--text mt-5 ml-0"
                    @click="isShowMarketListDialog = !isShowMarketListDialog"
                  >{{ selectedMarket.name }}</v-btn>
                  <!-- **********************************话题模态框 *********************************-->
                  <!-- **********************************话题模态框 *********************************-->
                  <!-- **********************************话题模态框 *********************************-->
                  <v-dialog v-model="isShowMarketListDialog" max-width="600px" persistent hide-overlay>
                    <v-card>
                      <v-card-title primary-title class="pb-0">
                        <v-spacer></v-spacer>
                        <h2>{{$t("postingcreate.chooseTopic")}}</h2>
                        <v-spacer></v-spacer>
                        <v-btn
                          flat
                          icon
                          right
                          color="pink"
                          @click="isShowMarketListDialog = !isShowMarketListDialog"
                        >
                          <v-icon>close</v-icon>
                        </v-btn>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text>
                        <div v-if="user.userName=='iob_official' || user.userName=='longnshort' || user.userName=='Fred' || user.userName=='louis' || user.userName=='shirley' || user.userName=='KateL' || user.userName=='renlywen'">
                          <v-btn
                            v-for="market in marketList"
                            :key="market.marketId"
                            depressed
                            small
                            color="primary"
                            class="white--text"
                            @click="selectMarket(market)"
                          >{{ market.name }}</v-btn>
                        </div>
                        <div v-else>
                          <v-btn
                            v-for="market in marketList"
                            v-if="'industrynews' == market.code"
                            :key="market.marketId"
                            depressed
                            small
                            color="primary"
                            class="white--text"
                            @click="selectMarket(market)"
                          >{{ market.name }}</v-btn>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                  <!-- 插入图片链接 -->
                  <v-dialog v-model="imageLinkDialog"  max-width="600px"  persistent hide-overlay>
                      <v-card class="pa-5">
                          <v-container grid-list-md>
                            <v-layout wrap>
                              <v-flex xs12 sm6 md12>
                                <v-text-field single-line v-model="imageLink" placeholder="Image Link" outline></v-text-field>
                                 <v-card-actions>
                                 <v-spacer></v-spacer>
                                  <v-btn small  color="primary" @click.prevent="insertImageLink">{{$t("common.confirm")}}</v-btn>
                                  <v-btn small  color="primary" @click.prevent="imageLinkDialog = false">{{$t("common.cancel")}}</v-btn>
                                 </v-card-actions>
                              </v-flex>
                            </v-layout>
                          </v-container>


                      </v-card>
                  </v-dialog>

                  <!-- @用户 -->
                  <v-dialog v-model="atUserDialog" class="ShapeUser" max-width="320px" persistent hide-overlay>
                      <v-card>
                          <v-card-text>
                              <div class="right">
                                  <v-btn flat icon right color="pink" @click="atUserDialog = !atUserDialog">
                                      <v-icon>close</v-icon>
                                  </v-btn>
                              </div>
                              <div v-show="userFollowList.length == 0" class="text-center">
                                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                              </div>
                              <div v-show="userFollowList.length != 0" class="mt-5 mb-3">
                                  <v-divider></v-divider>
                                  <div v-for="(userfollow,index) in userFollowList" @click="userfollowing(userfollow)" class="userFollow-li pointer mt-3 ml-5">
                                    <v-avatar color="primary" class="pointer" size="40">
                                      <img v-show="userfollow.image != null" :src="userfollow.image" :alt="userfollow.userName">
                                      <span v-show="userfollow.image == null" class="headline white--text">
                                      {{ userfollow.userName != null ? userfollow.userName.trim().substring(0, 1).toLocaleUpperCase() : '' }}</span>
                                    </v-avatar>
                                      <span id="followUserName">{{userfollow.nickName}}</span>&nbsp;
                                      <span class="primary--text font-12 ml-2">@{{userfollow.userName}}</span>
                                  </div>
                              </div>
                          </v-card-text>
                      </v-card>
                  </v-dialog>
                </div>
                <div>
                  <v-btn
                    class="mt-3 ml-0"
                    outline
                    small
                    color="primary darken-1"
                    v-for="(tagName,index) in tagNameArray"
                    :key="index"
                  >{{ tagName }}</v-btn>
                </div>
                <v-text-field
                  v-model="tagName"
                  :label="$t('postingcreate.tagName')"
                  @input="tagchange"
                  single-line
                  outline
                  class="mt-3"
                ></v-text-field>
                <span
                  id="tagruleValidate"
                  style="height: 10px;display: inline-block;color: red;margin-top: -15px;margin-left: 10px;"
                ></span>
                <div class="mt-3">
                  <v-btn
                    class="ma-0"
                    small
                    type="ghost"
                    :disabled="isDisabledOriginalBtn"
                    :class="formValidate.isOriginal?'primary':''"
                    @click.prevent="formValidate.isOriginal = true"
                  >{{ $t('postingcreate.original') }}</v-btn>
                  <v-btn
                    class="ma-0"
                    small
                    type="ghost"
                    :class="formValidate.isOriginal?'':'primary'"
                    @click.prevent="formValidate.isOriginal = false"
                  >{{ $t('postingcreate.repost') }}</v-btn>
                  <div v-if="formValidate.isOriginal">
                    <v-checkbox v-model="isAgreeOriginalTerms" color="primary" required>
                      <div slot="label" @click>
                        {{$t("postingcreate.agree")}}
                        <span class="primary--text pointer">
                          <a
                            href="/#/about/ContentPolicy"
                            target="_black"
                          ><<{{$t("postingcreate.contentPolicy")}}>></a>
                        </span>
                      </div>
                    </v-checkbox>
                  </div>
                  <div v-if="!formValidate.isOriginal">
                    <v-text-field
                      v-model="formValidate.originalLink"
                      :label="$t('postingcreate.rules.originalLink.label')"
                      :rules="originalLinkRules"
                      single-line
                      outline
                      class="mt-3"
                      required
                    ></v-text-field>
                  </div>
                </div>
                <div
                  class="font-16 primary--text mt-3"
                >{{ formValidate.postingId != null ? $t('postingcreate.message.updatePost') : "" }}</div>
                <div class="right">
                  <v-btn
                    color="primary"
                    small
                    type="ghost"
                    @click.prevent="isShowResetDialog = true"
                  >{{$t("postingcreate.Reset")}}</v-btn>
                  <v-btn
                    color="primary"
                    small
                    type="ghost"
                    @click.prevent="previewPostDialog = true"
                  >{{$t("postingcreate.preview.preview")}}</v-btn>
                  <v-btn
                    color="primary"
                    small
                    type="ghost"
                    @click.prevent="handleSubmit"
                    :loading="postLoading"
                  >{{$t("postingcreate.Post")}}</v-btn>
                </div>
                <div>
                  <v-dialog v-model="isShowResetDialog" width="40%" persistent hide-overlay>
                    <v-card>
                      <v-card-title primary-title>
                        <v-spacer></v-spacer>
                        <h2 class="fw-bold">{{$t("postingcreate.message.resetPost")}}</h2>
                        <v-spacer></v-spacer>
                        <v-btn flat icon right color="pink" @click="isShowResetDialog = false">
                          <v-icon>close</v-icon>
                        </v-btn>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text class="text-center">
                        <v-btn
                          color="primary"
                          type="ghost"
                          @click.prevent="handleReset"
                        >{{$t("common.confirm")}}</v-btn>
                        <v-btn
                          color="primary"
                          type="ghost"
                          @click.prevent="isShowResetDialog = false"
                        >{{$t("common.cancel")}}</v-btn>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </div>
              </v-form>
            </v-card>
          </v-flex>
        </v-layout>
        <!-- **************************************预览帖子*************************************** -->
        <v-layout>
          <v-flex>
            <v-dialog
              v-model="previewPostDialog"
              fullscreen
              hide-overlay
              transition="dialog-bottom-transition"
            >
              <v-card>
                <v-toolbar dark color="primary">
                  <v-toolbar-title>{{ $t('postingcreate.preview.preview') }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon dark @click="previewPostDialog = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-container>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 md12 sm12 lg10>
                      <h1
                        v-show="formValidate.postingTitle != ''"
                        class="fw-bold mb-3 display-1"
                      >{{formValidate.postingTitle}}</h1>
                      <h1
                        v-show="formValidate.postingTitle == ''"
                        class="fw-bold mb-3 display-1"
                      >{{ $t('postingcreate.preview.hint.title') }}</h1>
                      <ul class="list-unstyled mb-5">
                        <li class="userDetail">
                          <div class="imgleft">
                            <v-avatar color="primary" class="pointer" size="40">
                              <img
                                v-show="user != null && user.image != null"
                                :src="user.image"
                                :alt="user.userName"
                              >
                              <span
                                v-show="user == null || user.image == null"
                                class="headline white--text"
                              >{{ user.userName != null ? user.userName.trim().substring(0, 1).toLocaleUpperCase() : '' }}</span>
                            </v-avatar>
                          </div>
                          <div class="right-side ml-2">
                            <span class="title-1 font-md pointer primary--text">
                              {{user.nickName}}
                              <span>({{ user.reputationScore }})</span>
                            </span>
                            <span
                              class="ml-2 font-md"
                            >{{$t("common.at")}} {{ dateFormat(+new Date()) }}</span>
                          </div>
                        </li>
                      </ul>
                      <div
                        v-show="formValidate.postingContent != ''"
                        v-html="formValidate.postingContent"
                        class="mb-5 font-18 fw-400 ql-editor"
                      ></div>
                      <div
                        v-show="formValidate.postingContent == ''"
                        class="mb-5 font-18 fw-400"
                      >{{ $t('postingcreate.preview.hint.content') }}</div>
                      <!--标签-->
                      <div>
                        <v-btn
                          outline
                          small
                          color="primary darken-1"
                          v-for="(tagName,index) in tagNameArray"
                          :key="index"
                        >{{ tagName }}</v-btn>
                      </div>
                      <div class="userDetail mt-4">
                        <span class="font-md fw-semi-bold">
                          <v-icon small>timer</v-icon>
                          <span>{{ dateFormat(+new Date())}}&nbsp;{{$t("common.by")}}</span>
                        </span>
                        <div class="imgleft ml-3">
                          <v-avatar color="primary" class="pointer" size="32">
                            <img v-show="user.image != null" :src="user.image" :alt="user.userName">
                            <span
                              v-show="user.image == null"
                              class="headline white--text"
                            >{{ user.userName != null ? user.userName.trim().substring(0, 1).toLocaleUpperCase() : '' }}</span>
                          </v-avatar>
                        </div>
                        <div class="right-side ml-2 primary--text">
                          <span class="Author">
                            <span class="font-md fw-semi-bold">
                              {{user.nickName}}
                              <span>({{user.reputationScore}})</span>
                            </span>
                          </span>
                        </div>
                      </div>
                      <div class>
                        <!-- 原创或转载 -->
                        <span
                          v-if="formValidate.isOriginal"
                          class="primary--text ml-2 font-14 fw-700"
                        >{{ $t('postingsel.original') }}</span>
                        <span
                          v-if="!formValidate.isOriginal"
                          class="pointer primary--text ml-2 font-14 fw-700"
                        >
                          <a
                            :href="formValidate.originalLink"
                            target="_black"
                          >{{ $t('postingsel.source') }}</a>
                        </span>
                        <span class="social-list clearfix right">
                          <ul class="list-inline d-inline-block right">
                            <li>
                              <v-icon small :title="$t('posting.bonus')">fas fa-dollar-sign</v-icon>
                              <span>0.00</span>
                              <v-icon small :title="$t('posting.upvote')">thumb_up_alt</v-icon>
                              <span class="icon-title">0</span>
                              <v-icon small :title="$t('postingsel.tread')">thumb_down_alt</v-icon>
                              <span class="icon-title">0</span>
                              <v-icon small :title="$t('posting.comment')">fa fa-comment</v-icon>
                              <span class="icon-title">0</span>
                              <v-icon small :title="$t('posting.retweet')">fa fa-share</v-icon>
                              <span class="icon-title">0</span>
                              <v-icon small :title="$t('posting.save')">fa fa-star</v-icon>
                            </li>
                          </ul>
                        </span>
                      </div>
                      <v-divider></v-divider>
                      <div>
                        <v-btn
                          class="right"
                          color="primary"
                          :loading="postLoading"
                          @click="handleSubmit('formValidate',file)"
                        >{{$t("postingcreate.Post")}}</v-btn>
                        <v-btn
                          class="right"
                          color="primary"
                          type="ghost"
                          @click.prevent="previewPostDialog = false"
                        >{{$t("postingcreate.close")}}</v-btn>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-dialog>
          </v-flex>
        </v-layout>
      </v-container>
  </div>
</template>
<style>
.ql-toolbar {
  background-color: white;
}
.ql-container.ql-snow {
  height: 20em;
  resize: vertical;
}
/*.ql-snow .ql-tooltip[data-mode="video"] {
  left: 0px !important;
}
.ql-snow .ql-tooltip[data-mode="link"] {
  left: 0px !important;
}*/
.ql-snow .ql-tooltip {
   left: 0px !important;
  }
/*.ql-toolbar {
        border-style: none!important;
    }
    .ql-container{
        border-style: none!important;
    }
    .ql-toolbar-light {
        background-color: white;
        border-top: 2px solid rgba(0, 0, 0, 0.54)!important;
        border-left: 2px solid rgba(0, 0, 0, 0.54)!important;
        border-right: 2px solid rgba(0, 0, 0, 0.54)!important;
    }
    .ql-container-light {
        overflow-y: scroll;
        max-height: 400px;
        border-bottom: 2px solid rgba(0, 0, 0, 0.54)!important;
        border-left: 2px solid rgba(0, 0, 0, 0.54)!important;
        border-right: 2px solid rgba(0, 0, 0, 0.54)!important;
    }
    .ql-toolbar-dark {
        background-color: white;
        border-top: 2px solid rgba(255,255,255,0.7)!important;
        border-left: 2px solid rgba(255,255,255,0.7)!important;
        border-right: 2px solid rgba(255,255,255,0.7)!important;
    }
    .ql-container-dark {
        overflow-y: scroll;
        max-height: 400px;
        border-bottom: 2px solid rgba(255,255,255,0.7)!important;
        border-left: 2px solid rgba(255,255,255,0.7)!important;
        border-right: 2px solid rgba(255,255,255,0.7)!important;
    }*/
</style>
<script>
import Vue from "vue";
import config from "../../config.js";
import { mapGetters } from "vuex";
import QuillEditor from "vue-quill-editor";
import quillConfig from '../../assets/js/quill-config.js'
export default {
  data() {
    return {
      tagNameArray: [],           // 保存拆分后的数组
      postLoading: false,         // 加载进度环
      tagName: "",               // 标签名称
      marketList: [],           // 市场分类集合
      selectedMarket: {},       // 已选择的市场
      userFollowList:[],          // 查询所关注人集合
      atUserDialog:false,      // 艾特的人模态框
      imageLinkDialog: false,      // 插入图片链接的模态框
      imageLink: null,              // 插入的图片链接
      uploadFileLoading: null,    // 上传文件的加载中
      uploadUrl: config.baseUrl + "posting/uploadHeadPortrait", // 文件上传请求
      headers: {
        // 设置请求头
        Authorization: "Bearer " + localStorage.getItem("token")
      },
      quillEditorScrollHeight: 0,
      quillEditorScrollTop: 0,
      editorOption: quillConfig, // some quill options
      credentials: true, // 支持发送 cookie 凭证信息
      imgurl: "",
      file: null,
      videoUrl: null, // 插入视频的链接
      isShowResetDialog: false, // 是否显示重置提示模态框
      isShowMarketListDialog: false, // 是否显示市场列表模态框
      isShowInsertVideoDialog: false, // 是否显示插入视频模态框
      previewPostDialog: false, // 预览帖子对话框
      titleRules: [v => !!v || this.$t("postingcreate.Title")],
      originalLinkRules: [
        v => !!v || this.$t("postingcreate.rules.originalLink.label"),
        v =>
          /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/.test(v) ||
          this.$t("postingcreate.rules.originalLink.incorrect")
      ],
      formValidate: {
        // 发帖实体类
        postingId: null,
        postingTitle: "",
        postingContent: "",
        postingImg: "",
        postingUserId: this.$store.state.user.id,
        postingUserName: this.$store.state.user.name,
        marketId: null, // 所属市场(话题)主键
        isOriginal: false, // 是否原创
        originalLink: null, // 原文链接
        postingStatus: -1 // 发帖状态-1发帖0更新
      },
      isDisabledOriginalBtn: false, // 是否禁用原创按钮
      isAgreeOriginalTerms: true, // 是否同意原创条款
      uploadImageApi: '',     // 上传图片的API
      uploadFileApi: config.baseUrl + 'upload/file',      // 上传文件的API
      ruleValidate: {
        // 校验规则
        postingTitle: [
          {
            required: true,
            message: this.$t("postingcreate.postingTitle.message"),
            trigger: "blur"
          }
        ],
        postingContent: [
          {
            required: true,
            message: this.$t("postingcreate.postingContent.message"),
            trigger: "blur"
          },
          {
            type: "string",
            min: 20,
            message: this.$t("postingcreate.postingContent.messageless"),
            trigger: "blur"
          }
        ],
        marketId: [
          {
            required: true,
            message: this.$t("postingcreate.market.message"),
            trigger: "click"
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["user", "darkMode", "marketsList"]),
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  created() {},
  mounted() {
    quillConfig.initAtButton();
    quillConfig.initImageLinkButton();
    quillConfig.initUploadFileButton();
    this.getMarkets();
    this.loadPostCache();
    this.customizeLinkBlot();
    // 给@图标添加点击事件
    $(".ql-at").click( data => {
        this.userfollowShow();
    })
    // 给图片链接图标添加点击事件
    $(".ql-image-link").click( data => {
      this.imageLinkDialog = true;
    })
  },
  watch: {
    // '$route': 'loadPosting',
    $route(to, from) {
      if ("/post/create" == to.path) {
        this.loadPostCache();
      } else if ("/post/create" == from.path) {
        this.savePostCache();
      }
    },
    selectedMarket:{//深度监听，可监听到对象、数组的变化
      handler(newVal, oldVal){
        if ('industrynews' == newVal.code) {
          this.formValidate.isOriginal = false;
          this.isDisabledOriginalBtn = true;
        } else {
          this.isDisabledOriginalBtn = false;
        }
      },
      deep:true
    }

  },
  methods: {
    onEditorReady(editor) {},
    onEditorBlur(editor) {
      this.savePostCache();
    },
    onEditorFocus(editor) {
      this.savePostCache();
    },
    onEditorChange({ editor, html, text }) {
      // var div = document.getElementsByClassName('ql-container')[0];
      // div.scrollTop = div.scrollHeight;
      // let addLength = div.scrollHeight - this.quillEditorScrollHeight;
      // div.scrollTop = this.quillEditorScrollTop + addLength;
      // this.quillEditorScrollHeight = div.scrollHeight;
      // this.quillEditorScrollTop = div.scrollTop;
      // console.log(div.scrollTop + '\t' + addLength + '\t' + div.scrollHeight + '\t' + div.offsetHeight)
      this.savePostCache();
    },
    // 获得市场分类的集合
    getMarkets() {
      this.$http.get(config.baseUrl + "market/open/getMarkets").then(response => {
          let data = response.data;
          if (data.resCode == 0) {
            for (let i = 0; i < data.result.length; i++) {
                if ("industrynews" == data.result[i].code) {
                  this.selectedMarket = data.result[i];
                  this.formValidate.marketId = this.selectedMarket.marketId;
                  break;
                }
              }
            var flag = true;
            let role = this.$store.getters.role;
            if ( role != null && role.roleCode != null && role.roleCode != "USER" ) {
              flag = false;
            }
            if (flag) {
              for (let i = 0; i < data.result.length; i++) {
                if ("cheatalerts" == data.result[i].code) {
                  data.result.splice(i, 1);
                  break;
                }
              }
            }
            this.marketList = data.result;
          } else {
            this.marketList = [];
          }
        });
    },
    //图片上传之前压缩图片并上传
    uploadImageBefore(file){
      const loading = this.$Message.loading({
          content: this.$t("userSetting.uploading"),
          duration: 0
      });
      var fileData = new FormData();
      var url = config.baseUrl + 'posting/image/upload';
      var that = this;
      photoCompress(file, { quality: 0.5 }, function(base64Codes){
          var blob = convertBase64UrlToBlob(base64Codes);
          //upfile是键，file是值，就是要传的文件
          fileData.append('upfile', blob, file.name);
          that.$http.post(url, fileData).then(response => {
              let data = response.data;
              if (data.resCode == 0) {
                // 获取富文本组件实例
                let quill = that.$refs.myQuillEditor.quill;
                // 获取光标所在位置
                let length = quill.getSelection().index;
                // 插入图片，服务器返回的图片链接地址
                quill.insertEmbed(length, 'image', data.result);
                // 调整光标到最后
                quill.setSelection(length + 1);
              }
              setTimeout(loading, 500);
          }, error => {
              setTimeout(loading, 0);
              that.$Message.error(that.$t("common.fail"));
          });
      });
      return false;
    },
    // 自定义链接
    customizeLinkBlot(){
      var Quill = require('quill/dist/quill.js')
        var Link = Quill.import('formats/link');
        class FileBlot extends Link {  // 继承Link Blot
          static create(value) {
            let node = undefined
            if (value&&!value.href){  // 适应原本的Link Blot
              node = super.create(value);
            }
            else{  // 自定义Link Blot
              node = super.create(value.href);
              // 左键点击即下载
              // node.setAttribute('download', true);
              node.innerText = value.innerText;
            }
            return node;
          }
        }
        FileBlot.blotName = 'link';
        FileBlot.tagName = 'A';
        Quill.register(FileBlot);
    },
    // 上传文件之前
    uploadFileBefore(){
      const uploadFileLoading = this.$Message.loading({
          content: this.$t("userSetting.uploading"),
          duration: 0
      });
      this.uploadFileLoading = uploadFileLoading;
    },
    // 上传文件成功
    uploadFileSuccess(data){
        if (data.resCode == 0) {
          let fileUrl = data.result;
          let fileName = fileUrl.substring(fileUrl.lastIndexOf("/") + 1, fileUrl.length);
          // 获取富文本组件实例
          let quill = this.$refs.myQuillEditor.quill;
          // 获取光标所在位置
          let length = quill.selection.savedRange.index;
          let text = ' [Source: ' + fileUrl + '] ';
          // 插入链接，服务器返回的图片链接地址
          quill.insertEmbed(length, 'text', text);
          quill.insertEmbed(length, 'link', {href: fileUrl, innerText: fileName}, "api");
          // 调整光标
          quill.setSelection(length + text.length + fileName.length);
        } else {
          this.$Message.error(this.$t("common.fail"));
        }
        setTimeout(this.uploadFileLoading, 0);
    },
    // 插入图片链接
    insertImageLink(){
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill;
      // 获取光标所在位置
      let length = quill.selection.savedRange.index;
      // 插入图片，res为服务器返回的图片链接地址
      quill.insertEmbed(length, 'image', this.imageLink);
      this.imageLink = null;
      // 调整光标到最后
      quill.setSelection(length + 1);
      this.imageLinkDialog = false;
    },
    // 选择市场
    selectMarket(market) {
      this.formValidate.marketId = market.marketId;
      this.selectedMarket = market;
      this.isShowMarketListDialog = !this.isShowMarketListDialog;
    },
    // selectDefaultMarket(){
    //   const market = {
    //     code: "industrynews",
    //     description: "新闻模块",
    //     icon: "fas fa-poll-h",
    //     image: "https://images.iob.community/SIP-test/material/topic/1557728044688.news.jpg",
    //     marketId: "4028e2a76aa0d90c016aafdbf3d40000",
    //     marketTypeId: "caaf7e6d4ab811e9992f525400695e5f",
    //     name: "Industry News",
    //     sort: 2,
    //     time: 1557727544745
    //   };
    //   this.selectMarket(market);
    // },
    // 查询关注用户集合
    userfollowShow(){
        this.atUserDialog = true;
        let url = config.baseUrl + "follow/open/getFollowingUserDtoByUserId/" + this.user.userId;
        this.$http.get(url).then((successData) => {
            let data = successData.data;
            if(data.resCode == 0){
                this.userFollowList = data.result;
            } else {
                this.userFollowList = [];
            }
        });
    },
    //点击@对象传递用户名
    userfollowing(userfollow){
        let userName="&nbsp; <a href='" + config.ip + "#/user/profile/@" + userfollow.userName + "'  class='primary--text'>"  + "@" + userfollow.userName + "</a>&nbsp; ";
        this.formValidate.postingContent = this.formValidate.postingContent + userName;
        let quill = this.$refs.myQuillEditor.quill;
        let length = quill.selection.savedRange.index;
        quill.insertEmbed(length, 'text', ' ');
        quill.insertEmbed(length, 'link', {href: config.ip + "#/user/profile/@" + userfollow.userName, innerText: "@" + userfollow.userName}, "api");
        quill.setSelection(length + userfollow.userName.length + 1);
        this.atUserDialog = false;
    },
    // 标签输入判断
    tagchange() {
      let rule = /^[a-zA-Z0-9, ]*$/;
      // 正则验证
      if (!rule.test(this.tagName)) {
        document.getElementById("tagruleValidate").innerText = this.$t(
          "postingcreate.message.rule"
        );
        return false;
      }
      // 区分中英文的逗号
      if (this.tagName.indexOf(",") != -1) {
        this.tagNameArray = this.tagName.split(",");
        for (var i = 0; i < this.tagNameArray.length; i++) {
          if (this.tagNameArray[i].indexOf("，") != -1) {
            var array = this.tagNameArray[i].split("，");
            this.tagNameArray.splice(i, 1);
            for (var j = 0; j < array.length; j++) {
              this.tagNameArray.splice(i, 0, array[j]);
            }
          }
        }
      } else if (this.tagName.indexOf("，") != -1) {
        this.tagNameArray = this.tagName.split("，");
      } else {
        this.tagNameArray = [];
        if (this.tagName != "") {
          this.tagNameArray[0] = this.tagName;
        }
      }
      // 判断每个标签的长度
      for (let index in this.tagNameArray) {
        if (this.tagNameArray[index].length > 24) {
          document.getElementById("tagruleValidate").innerText = this.$t(
            "postingcreate.message.tagNameLength"
          );
          return false;
        }
      }
      // 判断总标签数量
      if (this.tagNameArray.length > 5) {
        document.getElementById("tagruleValidate").innerText = this.$t(
          "postingcreate.message.length"
        );
        this.tagNameArray = this.tagNameArray.slice(0, 5);
        return false;
      } else {
        document.getElementById("tagruleValidate").innerText = "";
        localStorage.setItem("SIP-tagName", this.tagName);
        return true;
      }
    },
    // 提交表单,发布帖子
    handleSubmit() {
      if (localStorage.getItem("token")) {
        if(this.user.userName!='iob_official' && this.user.userName!='longnshort' && this.user.userName!='louis' && this.user.userName!='shirley' && this.user.userName!='Fred' && this.user.userName!='KateL' && this.user.userName!='renlywen'){
          this.$Notice.error({
              title: this.$t('postingcreate.notification'),
              desc: this.$t('postingcreate.cannotPostMessage'),
              duration: 5
          });
          return;
        }
        if (this.$refs["formValidate"].validate()) {
          if (this.formValidate.postingContent == "") {
            return;
          }
          if (this.formValidate.marketId == null) {
            return;
          }
          let flag = this.tagchange();
          if (!flag) {
            return;
          }
          if (this.formValidate.isOriginal) {
            if (this.isAgreeOriginalTerms) {
              this.formValidate.originalLink = null;
            } else {
              return;
            }
          }
          this.postLoading = true;
          let url =
            config.baseUrl + "posting/create?tagName=" + this.tagNameArray;
          this.$http.post(url, this.formValidate, this.tagName).then(
            successData => {
              let data = successData.data;
              if (data.resCode == 0) {
                this.postLoading = false;
                this.handleReset();
                this.previewPostDialog = false;
                this.goPostingsel(
                  data.result.postingId,
                  data.result.postingUserName
                );
              } else {
                this.postLoading = false;
                this.$Message.error(this.$t("common.fail"));
              }
            },
            errorData => {
              this.postLoading = false;
            }
          );
        } else {
          this.postLoading = false;
        }
      } else {
        this.postLoading = false;
        this.$store.state.loginModal = true;
      }
    },
    // 重置数据
    handleReset() {
      this.formValidate.postingTitle = "";
      this.formValidate.postingContent = "";
      this.formValidate.postingStatus = -1;
      this.formValidate.postingId = null;
      this.formValidate.marketId = null;
      this.formValidate.isOriginal = false;
      this.formValidate.originalLink = null;
      this.isAgreeOriginalTerms = false;
      this.selectedMarket = {};
      this.tagNameArray = [];
      this.tagName = ""; //标签名称
      this.postLoading = false;
      this.isShowResetDialog = false;
    },
    // 发帖成功后跳转到帖子页面
    goPostingsel(postingId, username) {
      this.$router.push({
        name: "postingsel",
        params: {
          username: username,
          postingId: postingId
        }
      });
    },
    // 保存帖子缓存
    savePostCache() {
      localStorage.setItem("SIP-editPost", JSON.stringify(this.formValidate));
      localStorage.setItem("SIP-tagName", this.tagName);
    },
    // 加载帖子缓存
    loadPostCache() {
      let editPost = JSON.parse(localStorage.getItem("SIP-editPost"));
      if (editPost) {
        this.formValidate.postingId = editPost.postingId;
        this.formValidate.postingTitle = editPost.postingTitle;
        this.formValidate.postingContent = editPost.postingContent;
        this.formValidate.isOriginal = editPost.isOriginal;
        this.formValidate.originalLink = editPost.originalLink;
        this.formValidate.postingStatus = -1; // 发布新帖子
        if (this.formValidate.postingId) {
          this.formValidate.postingStatus = 0; // 更新帖子
        }
        this.formValidate.marketId = editPost.marketId;
        if (this.formValidate.marketId) {
          for (var j = 0; j < this.marketsList.length; j++) {
            if (this.marketsList[j].marketId == this.formValidate.marketId) {
              this.selectedMarket = this.marketsList[j];
              break;
            } else {
              this.selectedMarket = {};
            }
          }
        }
        let tagName = localStorage.getItem("SIP-tagName");
        if (!tagName) {
          tagName = "";
          let tagList = editPost.tagList;
          if (tagList != null && tagList != "") {
            for (let i = 0; i < tagList.length; i++) {
              if (i == 0) {
                tagName += tagList[i].tagName;
              } else {
                tagName += "," + tagList[i].tagName;
              }
            }
          }
        }
        this.tagName = tagName;
        this.tagchange();
      }
    },
    //日期格式化
    dateFormat(time) {
      let timeOffset = -28800000;
      if (this.user) {
        timeOffset = this.user.timeOffset;
      }
      return formatDate(time, timeOffset, this.$i18n.locale);
    }
  }
};
</script>



// WEBPACK FOOTER //
// CreatePost.vue?dd2be6bc